package io.horion.cv.models

import io.horion.cv.api.datasource.motivation.Letter

data class ApplyJob(
    val id: String = "",
    val job: String = "",
    val user: String = "",
    val cv: String = "",
    val letter: Letter? = null,
    val status: ApplyJobStatus = ApplyJobStatus.PENDING,
    val createdAt: String = "",
    val updatedAt: String = "",
){
}
